import { render, staticRenderFns } from "./TaskBlockPage.vue?vue&type=template&id=af532c06&scoped=true"
import script from "./TaskBlockPage.vue?vue&type=script&lang=js"
export * from "./TaskBlockPage.vue?vue&type=script&lang=js"
import style0 from "./TaskBlockPage.vue?vue&type=style&index=0&id=af532c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af532c06",
  null
  
)

export default component.exports